export default __webpack_public_path__ + "static/media/b2.e9e16206.svg";